import React, { useState, useEffect } from 'react';
import PropertyImages from '../componance/Modal/PropertyImages';
import { Bed, Bath, Maximize, ParkingCircle, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import CreatePropertyForm from '../contacts/CreatePropertyForm';
import AppointmentForm from '../contacts/AppointmentForm'
const PropertyList = ({ properties, openModal, favorites, toggleFavorite, currency }) => {
  const exchangeRate = 36;
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
const [showFormapp, setShowFormapp] = useState(false);
  const [showForm, setShowForm] = useState(false); // 🔹 state สำหรับ modal
  
    const [selectedProperty, setSelectedProperty] = useState(null); // 🔹 เก็บ property ที่จะส่งไปใน form
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

   const handleOpenForm = (e, property) => {
    e.stopPropagation();
    setSelectedProperty(property);
    setShowForm(true);
  };
  
  const handleOpenFormApp = (e, property) => {
    e.stopPropagation();
    setSelectedProperty(property);
    setShowFormapp(true);
  };
   const handleCloseForm = () => {
    setShowForm(false);
    setShowFormapp(false);
    setSelectedProperty(null);
  };

  // ✅ ปิด scroll หน้าเว็บเมื่อ modal เปิด
  useEffect(() => {
    if (showForm || showFormapp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // cleanup
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showForm, showFormapp]);
  const formatPrice = (price) => {
    if (!price) return '-';
    const numericPrice = Number(price);
    if (isNaN(numericPrice)) return price;
    return currency === 'THB'
      ? `${numericPrice.toLocaleString()} THB`
      : `${(numericPrice / exchangeRate).toFixed(2)} USD`;
  };

  const featuredProperties = properties.filter(property => property.featured);

  const formatDateWithTranslate = (date, t) => {
  const d = new Date(date);
  const month = d.toLocaleString('en-EN', { month: 'long' });
  return `${t(month)} ${d.getDate()}, ${d.getFullYear()}`;
};
  return (
    <div
      style={{
        ...styles.propertyListContainer,
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', // mobile = 1 card per row
      }}
    >
      {featuredProperties.map((property) => {
        const isFavorited = favorites.some((fav) => fav.property_id === property.property_id);

        let images = [];
        if (Array.isArray(property.images)) {
          images = property.images;
        } else if (typeof property.images === 'string') {
          images = property.images.replace(/^{|}$/g, '').split(',').map(img => img.trim());
        } else if (property.image) {
          images = [property.image];
        }

        return (
          <div
            key={property.property_id}
            style={styles.propertyCard}
            onClick={() => openModal(property)}
          >
              {property.status !== 'Sold Out' && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleFavorite(property);
              }}
              style={styles.favoriteButton}
            >
              {isFavorited ? '❤️' : '🤍'}
            </button>
          )}

            <div style={styles.imageContainer}>
              <div style={styles.propertyIdWrapper}>
                <span style={styles.propertyIdText}>{t('SHA ID')}: {property.property_id}</span>
                {property.featured && (
                  <span style={styles.hotDealInline}>🔥 Hot Deal</span>
                )}
                 {property.furnished && (
                  <span style={styles.furnishedInline}> {t("Furnished_full")}</span>
                )}
              </div>
              <img src="/img/logo3.png" alt="Logo" style={styles.logoUnderId} />
              <PropertyImages images={images} propertyName={property.name} />
            </div>
            {property.status === 'Sold Out' && (
                <div
                  style={{
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    width: '120px',
                    height: '120px',
                    overflow: 'hidden',
                    pointerEvents: 'none',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '20px',      // ปรับขึ้น/ลง
                      right: '-60px',   // เพิ่มค่าลบเพื่อเลื่อนออกไปข้างหลังอีก
                      width: '200px',
                      textAlign: 'center',
                      backgroundColor: '#E74C3C',
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      padding: '5px 0',
                      transform: 'rotate(45deg)',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                    }}
                  >
                    SOLD OUT!
                  </div>
                </div>
              )}

               {/* ✅ Status Badge เฉพาะ Buy / Rent */}
          {(property.status === 'Buy' || property.status === 'Rent') && (
            <div
              style={{
                ...styles.statusBadge,
                backgroundColor:
                  property.status === 'Buy'
                    ? '#F39C12'
                    : '#3498db',
              }}
            >
              <div>{t(`status.${property.status}`)}</div>
            </div>
          )}

            <div style={styles.namePriceRow}>
              <div style={styles.propertyNameLeft}>
                {property.name}
                {property.type && (
                  <div style={styles.propertyType}>{t(property.type)}</div>
                )}
              </div>
            
            </div>
        <div style={styles.priceLocationRow}>
              <div style={styles.propertyPriceLeft}>{formatPrice(property.price)}</div>
              <div style={styles.propertyLoRight}>
                <MapPin size={15} /> {property.location ? t(property.location) : '-'}
              </div>
            </div>
      

            <div style={styles.infoOverlay}>
                                      <div style={styles.infoItem}>
                                        <Bed size={20} />
                                        <div>{property.bedrooms > 0 ? `${property.bedrooms}  ${t('Bedrooms')}` : '-'}</div>
                                      </div>
                                      <div style={styles.infoItem}>
                                        <Bath size={20} />
                                        <div>{property.bathrooms > 0 ? `${property.bathrooms} ${t('Bathrooms')} ` : '-'}</div>
                                      </div>
                                      <div style={styles.infoItem}>
                                        <ParkingCircle size={20} />
                                        <div>{property.parking > 0 ? `${property.parking} ${t('Parking')}` : '-'}</div>
                                      </div>
                                <div style={styles.infoItem}>
                                      <Maximize size={20} />
                                      <div>
                                        {property.buildingArea > 0 
                                          ? `${property.buildingArea} ${t('sq.m.')}` 
                                          : '-'}
                                      </div>
                                    </div>
              
            
                           </div>

            {/* ✅ ส่วนท้าย เพิ่มปุ่มขอข้อมูล */}
            <div style={styles.companyInfoBar}>
            
             
              <button
                style={styles.requestButton}
                onClick={(e) => handleOpenForm(e, property)}
              >
                {t('Request Details')}
              </button>
               <button
                style={styles.requestButton}
                onClick={(e) => handleOpenFormApp(e, property)}
              >
                {t('Appointment')}
              </button>
            </div>
          {/* ✅ วันที่สร้างโพสต์ */}
          <div style={styles.createdAt}>
          {t('Posted on')}: {formatDateWithTranslate(property.created_at, t)}
          </div>

          </div>
        );
      })}

        {/* ✅ Modal สำหรับ CreatePropertyForm */}
          {showForm && (
            <div
              style={styles.modalOverlay}
              onClick={handleCloseForm} // ✅ คลิกที่พื้นหลังเพื่อปิด
            >
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()} // ✅ ป้องกันไม่ให้คลิกในกล่องแล้วปิด
              >
                <button style={styles.closeModal} onClick={handleCloseForm}>
                  ✕
                </button>
                
                <CreatePropertyForm property={selectedProperty} />
              </div>
            </div>
          )}

          {/* ✅ Modal สำหรับ AppointmentForm */}
          {showFormapp && (
            <div
              style={styles.modalOverlay}
              onClick={handleCloseForm} // ✅ คลิกพื้นหลังเพื่อปิด
            >
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()} // ✅ ป้องกันปิดเมื่อคลิกในเนื้อหา
              >
                <button style={styles.closeModal} onClick={handleCloseForm}>
                  ✕
                </button>
            
                <AppointmentForm property={selectedProperty} />
              </div>
            </div>
          )}
    </div>
  );
};

const styles = {
  propertyListContainer: {
    display: 'grid',
    gap: '20px',
    justifyItems: 'center',
    marginTop: '20px',
  },
  priceLocationRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 10px',
    marginTop: '5px',
  },
  propertyPriceLeft: {
    fontSize: '26px',
    fontWeight: 'bold',
    color: '#FFF',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  createdAt: {
  fontSize: '12px',
  color: '#fff',
  textAlign: 'left',
  marginTop: '4px',
  marginRight: '10px',
  fontStyle: 'italic',
  fontFamily: `'Roboto Condensed', 'Kanit', sans-serif`,
},
requestButton: {
    backgroundColor: '#fff',
    color: '#192c43',
    border: 'none',
    borderRadius: '6px',
    padding: '5px 10px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'all 0.2s',
    fontFamily: `'Roboto Condensed', 'Kanit', sans-serif`,
  },
  propertyCard: {
    position: 'relative',
    width: '100%',
    maxWidth: '360px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    textAlign: 'center',
    padding: '10px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '500px',
    transition: 'transform 0.3s, box-shadow 0.3s',
    background: 'linear-gradient(135deg, #0f1c2e 0%, #1d3557 50%, #457b9d 100%)',
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // ✅ สีดำโปร่ง
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    backdropFilter: "blur(2px)", // เพิ่มความสวยละมุน
  },
  modalContent: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "25px",
    width: "420px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    position: "relative",
  },
  closeModal: {
    position: "absolute",
    top: "6vh",
    right: "6vh",
    border: "none",
    background: "transparent",
    fontSize: "1.5rem",
    cursor: "pointer",
    color: "#fff"
  },
  favoriteButton: { position: 'absolute', top: '40px', right: '10px', background: 'transparent', border: 'none', fontSize: '20px', cursor: 'pointer', zIndex: 999 },
  imageContainer: { position: 'relative' },
  logoUnderId: { position: 'absolute', top: '35px', left: '10px', width: '50px', height: 'auto', zIndex: 2 },
  propertyIdWrapper: { position: 'absolute', top: '10px', left: '10px', display: 'flex', alignItems: 'center', zIndex: 2 },
  propertyIdText: { backgroundColor: 'rgba(0,0,0,0.6)', color: '#fff', padding: '4px 8px', fontSize: '12px', borderRadius: '4px', fontWeight: 'bold' },
  hotDealInline: { background: 'linear-gradient(135deg, #ffa733, #ff6b00, #cc5200)', color: '#fff', padding: '2px 6px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', marginLeft: '6px' },
 furnishedInline:{ background: 'linear-gradient(90deg, #1a8cff, #0a71e7)', color: '#fff', padding: '2px 6px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', marginLeft: '6px' },
  statusBadge: { position: 'absolute', top: '10px', right: '10px', color: '#fff', padding: '5px 10px', fontSize: '14px', fontWeight: 'bold' },
  namePriceRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 10px', marginTop: '12px' },
  propertyNameLeft: {    fontSize: '16px', fontWeight: '600', color: '#fff', textAlign: 'left', flex: 1, wordBreak: 'break-word',fontFamily: `'Roboto Condensed', 'Kanit', sans-serif`, },
  propertyPriceRight: { fontSize: '18px', fontWeight: 'bold', color: '#fff', textAlign: 'right', marginLeft: '10px', whiteSpace: 'nowrap' },
  propertyLoRight: { fontSize: '12px', fontWeight: 'bold', color: '#fff', textAlign: 'right', paddingRight: '10px', whiteSpace: 'nowrap' },
  infoOverlay: { display: 'flex', justifyContent: 'space-around', alignItems: 'center', backgroundColor: 'rgba(30,62,93,0.8)', color: '#fff', padding: '10px 0', borderRadius: '20px', fontSize: '13px', fontWeight: '500', margin: '5px 0' },
  infoItem: { display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 },
companyInfoBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(to right, #192c43ff, #192c43ff)',
    padding: '10px',
    borderRadius: '0 0 8px 8px',
    width: '100%',
    marginLeft: '-10px',
    marginBottom: '-10px',
    gap: '10px',
  },  companyLogo: { width: '30px', height: 'auto', marginRight: '10px' },
  companyName: { fontSize: '16px', fontWeight: '600', color: '#fff' },
  propertyType: { fontSize: '12px', color: '#888', fontWeight: '500', marginTop: '4px' },
};

export default PropertyList;
